module.exports = __webpack_public_path__ + "373200eb2058ae390a467004fd103c58.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/news/4/spotinxFIPP.jpg
// module id = 245
// module chunks = 0